import React, { FC, useCallback } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useAppStore } from 'stores/state';
import { useNameSuggestions } from 'hooks/useNameSuggestions';
import { Button, SkeletonGroup, SkeletonRectangle, Text, TextButton } from '@wix/design-system';
import styles from '../SelectSiteNameStep.scss';
import { SparklesSmall, RefreshSmall } from '@wix/wix-ui-icons-common';

export const SelectSiteNameStepSuggestions: FC = () => {
  const { t } = useTranslation();
  const { suggestions, isLoading, refetch } = useNameSuggestions();

  const setSiteName = useAppStore((state) => state.setSiteName);

  const renderOptions = useCallback(() => {
    if (isLoading) {
      return (
        <SkeletonGroup>
          <div className={styles.selectSiteNameStepSuggestionsOptions}>
            {[...Array.from({ length: 5 })].map((_, index) => (
              <SkeletonRectangle key={index} width="100px" height="32px" />
            ))}
          </div>
        </SkeletonGroup>
      );
    }

    return (
      <div className={styles.selectSiteNameStepSuggestionsOptions}>
        {suggestions?.map((name) => (
          <Button
            onClick={() => setSiteName(name)}
            prefixIcon={<SparklesSmall />}
            priority="secondary"
            size="small"
            skin="dark"
            key={name}
          >
            {name}
          </Button>
        ))}
      </div>
    );
  }, [suggestions, isLoading, setSiteName]);

  return (
    <div className={styles.selectSiteNameStepSuggestions}>
      <div className={styles.selectSiteNameStepSuggestionsHeader}>
        <Text>{t('select-site-name-step.suggestions.title')}</Text>
        <TextButton disabled={isLoading} onClick={() => refetch()} prefixIcon={<RefreshSmall />} size="small">
          {t('select-site-name-step.suggestions.regenerate')}
        </TextButton>
      </div>
      {renderOptions()}
    </div>
  );
};
